module.exports = __webpack_public_path__ + "img/Questions.656577cd.png";